let forms = {
   customer_details: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:200", model: "names", label: "Isuer Name (Person or Company)", },
         { type: 'mobile', class: 'col-12', model: 'phone_number', filterable: true,validation: 'required|phone', label: 'Phone Number' },
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:150|email", model: "email", label: "Email Address", },
         { type: 'checkbox', class: 'col-12 custom-check', model: 'terms', validation: 'required', label: 'I agree to the <a href="#" target="_blank">Terms &amp; Conditions</a>'},
      ]
   },
   voucher_cards: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: 'slider', step: 500, min: 500, max: 20000, model: 'amount', label: 'Amount', show_stops: true, class: 'col-12', validation: 'required'},
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:150", model: "names", label: "Names", placeholder: "e.g John Mwaniki" },
         { type: 'mobile', class: 'col-12', model: 'phone_number', filterable: true,validation: 'required|phone', label: 'Phone Number' },
         { type: "text", form_type: "text", class: "col-12", validation: "required|min:3|max:150|email", model: "email", label: "Email Address",placeholder: 'e.g john.mwaniki@gmail.com' },
      ]
   },
   payment_type: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         {
            type: 'select', class: 'col-md-10 col-lg-8 col-xl-7', model: 'payment_type', filterable: true, clearable: true,options: [
               { val: 'mpesa_stk_push', label: 'M-Pesa STK Push' },
            ], validation: 'required', label: 'Payment Type', sub_label: 'Select a payment type and click next.'
         },
         // { type: 'button', btnClass: 'btn-primary btn-request', class: 'col-md-4 offset-md-2', model: 'request_payment', label: 'Request Payment'}
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
}